import { createSlice } from '@reduxjs/toolkit';

export const alertSlice = createSlice({
	name: 'alert',
	initialState: {
		type: 'success',
		message: '',
		duration: 5000,
	},
	reducers: {
		setAlert: function (state, action) {
			if (typeof action.payload === 'object') {
				state.type = action.payload.type || 'success';
				state.message = action.payload.message || '';
				state.duration = action.payload.duration || 5000;
			} else {
				state.type = 'success';
				state.duration = 5000;
				state.message = action.payload;
			}
		},
	},
});

export const { setAlert } = alertSlice.actions;
export default alertSlice.reducer;
